<template>
	<div class="c-step-by-step__media-stack">
		<div
			v-for="(s, i) in steps"
			:key="s.id"
			class="c-step-by-step__media-item"
			:data-active="i === activeIndex"
			:data-expanded="i === activeIndex"
			:inert="i === activeIndex ? false : true"
			:aria-hidden="i === activeIndex ? 'false' : 'true'"
		>
			<template v-if="s.externalVideoSource">
				<StepByStepVideoItemLoop
					:is-expanded="i === activeIndex"
					:video-url="s.externalVideoSource"
					video-wrapper-class="c-step-by-step__video"
					:video-id="`sbs-media-${s.id}`"
				/>
			</template>

			<template v-else-if="s.imageUrl">
				<img
					class="c-step-by-step__image"
					:src="s.imageUrl"
					:alt="s.imageAltText || ''"
				/>
			</template>
		</div>
	</div>
</template>

<script setup lang="ts">
import StepByStepVideoItemLoop from './StepByStepVideoItemLoop.vue';

type Step = {
	id: string;
	headline: string;
	externalVideoSource?: string;
	imageUrl?: string;
	imageAltText?: string;
};

defineProps<{
	steps: Step[];
	activeIndex: number;
}>();
</script>

<style lang="scss">
.c-step-by-step__media-stack {
	aspect-ratio: 1;
	position: relative;
}

.c-step-by-step__media-item {
	--transition-time: 0.3s;

	transition: opacity var(--transition-time);
	opacity: 0;
	position: absolute;
	inset: 0;

	&[data-expanded='true'] {
		opacity: 1;
		z-index: 10;
	}
}
</style>
